module.exports = __webpack_public_path__ + "static/survey_image-b2f2d71a92a163bfa5f1bdf4c07f87d1.jpeg";